import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import projectsArray from "../../../components/Projects/projectsArray";
import ProjectsItem from "../../../components/Projects/ProjectsItem";

export default class ProjectsSliderUKR extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      dots: false,
      dotsClass: "slickDots",
      infinite: true,
      arrows: false,
      autoplay: false,
      pauseOnHover: true,
      speed: 300,
      centerPadding: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
          },
        },
      ],
    };

    return (
      <div className="slider">
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {projectsArray.map(({ ukrTitle, image, id, link, gitLink }) => (
            <div className="slide" key={`project-${id}-EN`}>
              <ProjectsItem
                title={ukrTitle}
                link={link}
                image={image}
                gitLink={gitLink}
              />
            </div>
          ))}
        </Slider>
        <div style={{ textAlign: "center" }}>
          <button className="slick-prev" onClick={this.previous}>
            ◄
          </button>
          <button className="slick-next" onClick={this.next}>
            ►
          </button>
        </div>
      </div>
    );
  }
}
